export default "__VITE_ASSET__D6SHrhy1__"